import { HttpService } from '@/shared/api/services/HttpService.ts';
import { buildUrlForServiceName } from '@/connection/url-retriever.ts';
import conf from '@/shared/config/useConfig.ts';

export class SharedAvallinieService extends HttpService {
  protected avallinieServiceBaseUrl = `${buildUrlForServiceName(conf.partnerserviceName)}/partnerservice/api/private/v2`;
}
